import {
    getGoodsState,
    getGoodsType,
    getCollationRules,
    getCouponStatus,
    getDiscountType,
    getPublishType,
    getGrantObj,
    getPromotionType,
    getCycleTypes,
    getDayTypes
} from 'enumeration/mall.js'
import { fullReductionTypes } from 'cps/mall-manage/pt-promotion-coupon/promotion-option.js'
import { userOrderTypes, sampleType, identityCardTypes, refundModes } from 'json/goods-order-options'
import { exchangeTimeDimensions } from 'json/integral-goods-options'
import { getOrderStatus, getIntegralOrderStatus, getRefundmentTypeIntegral, getOrderRefundIntegralStatus, getOnlyRefundReason, getChannelName, getRefundReturn } from 'enumeration/goods-order.js'
import { getEnumeration } from 'enumeration'
import {
    goodsBelongLabels,
    collectionsLabels,
    rewardStatus,
    promotionStatusArr,
    paymentModes,
    promotionColors,
    usedTypes,
    shippingMode,
    invoiceProvideTypesDo,
    invoiceObject
} from 'json/mall-options'
import { cashCount, maxValueMethod, minValueMethod, genderFormat } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
import datas from './index'
import { invalidReasonsArr } from 'json/index'
export default {
    goodsList(data) {
        data.forEach((item, index) => {
            item.index = index + 1
                //   item.goods_state = item.goodsDTO && item.goodsDTO.state && getGoodsState(item.goodsDTO.state)
            item.goods_state = item.goodsDTO && this.goodsStates(item.goodsDTO)
            item.goodsOtherInfoDTO = item.goodsOtherInfoDTO || {}
            let goodsData = (item.goodsDTO && item.goodsDTO.goodsData) || {}
            item.goods_type = goodsData.type && getGoodsType(goodsData.type)
            item.goods_type = (item.goods_type && item.goods_type.indexOf('产品') > -1 && item.goods_type.replace('产品', '')) || item.goods_type
            item.putOnSaleTime = item.goodsDTO && item.goodsDTO.putOnSaleTime && timeutils.format(item.goodsDTO.putOnSaleTime)
            item.mall_visible = goodsData.mallVisible ? '是' : '否'
            item.recommend = (item.goodsOtherInfoDTO && item.goodsOtherInfoDTO.recommend) ? '是' : '否'
            item.sticky = (item.goodsOtherInfoDTO && item.goodsOtherInfoDTO.sticky) ? '是' : '否'
            item.goodsBelong = getEnumeration(goodsData.goodsBelong, goodsBelongLabels)
            item.paymentModes = goodsData.paymentModes
            item.goodsOtherInfoDTO.ranking = item.goodsOtherInfoDTO.ranking || 0
                // if (goodsData.specifications &&
                //   goodsData.specifications.length > 1) {
                //   if (goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
                //     item.final_price = '¥' + cashCount(goodsData.priceIntervalMin, true, 2) + '-¥' + cashCount(goodsData.priceIntervalMax, true, 2)
                //   }
                //   if (goodsData.paymentModes && goodsData.paymentModes.length && goodsData.paymentModes.indexOf('LUMP_SUM') > -1) {
                //     if (goodsData.depositIntervalMin && goodsData.depositIntervalMax) {
                //       item.final_deposit = '¥' + cashCount(goodsData.depositIntervalMin, true, 2) + '-¥' + cashCount(goodsData.depositIntervalMax, true, 2)
                //     }
                //     if (goodsData.balanceIntervalMin && goodsData.balanceIntervalMax) {
                //       item.final_balance = '¥' + cashCount(goodsData.balanceIntervalMin, true, 2) + '-¥' + cashCount(goodsData.balanceIntervalMax, true, 2)
                //     }
                //   }
                // }
            item.address = null
            if (goodsData.addresses && goodsData.addresses.length) {
                goodsData.addresses.forEach(etem => {
                    item.address = item.address ? (item.address + '/' + etem) : etem
                })
            }
            // item.address=goodsData.addresses
            let specificationsItems = goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items
            if (specificationsItems && specificationsItems.length) {
                if (specificationsItems.length > 1) {
                    if (goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
                        item.final_price = '¥' + cashCount(goodsData.priceIntervalMin, true, 2) + '-¥' + cashCount(goodsData.priceIntervalMax, true, 2)
                    }
                    if (goodsData.paymentModes && goodsData.paymentModes.length && goodsData.paymentModes.indexOf('LUMP_SUM') > -1) {
                        if (goodsData.depositIntervalMin && goodsData.depositIntervalMax) {
                            item.final_deposit = '¥' + cashCount(goodsData.depositIntervalMin, true, 2) + '-¥' + cashCount(goodsData.depositIntervalMax, true, 2)
                        }
                        if (goodsData.balanceIntervalMin && goodsData.balanceIntervalMax) {
                            item.final_balance = '¥' + cashCount(goodsData.balanceIntervalMin, true, 2) + '-¥' + cashCount(goodsData.balanceIntervalMax, true, 2)
                        }
                    }
                } else {
                    item.final_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true, 2)
                    item.final_deposit = specificationsItems[0].deposit && '¥' + cashCount(specificationsItems[0].deposit, true, 2)
                    item.final_balance = specificationsItems[0].balance && '¥' + cashCount(specificationsItems[0].balance, true, 2)
                }
            } else {
                item.final_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true, 2)
                item.final_deposit = goodsData.noSpecificationsDeposit && '¥' + cashCount(goodsData.noSpecificationsDeposit, true, 2)
                item.final_balance = goodsData.noSpecificationsBalance && '¥' + cashCount(goodsData.noSpecificationsBalance, true, 2)
            }
            if (item.abstractPromotionEvents && item.abstractPromotionEvents.length > 0) {
                let promotionEvents = item.abstractPromotionEvents || []
                promotionEvents.forEach(etem => {
                    let promotionData = etem.promotionData || {}
                    etem.promotionStatusColor = promotionColors[promotionData.promotionType]
                    etem.promotionStartTime = timeutils.format(promotionData.startTime)
                    etem.promotionEndTime = timeutils.format(promotionData.endTime)
                })
            }
            item.promotionEvent = item.promotionEvent || item.abstractPromotionEvent || {}
            item.promotionData = (item.promotionEvent && item.promotionEvent.promotionData) || null
            let promotionData = (item.promotionEvent && item.promotionEvent.promotionData) || {}
            let specifications = item.specifications || []
            item.promotionStatusColor = promotionColors[promotionData.promotionType]
            if (specifications.length > 1) {
                item.promotionMaxPrice = cashCount(maxValueMethod(specifications, 'price'), true, 2)
                item.promotionMinPrice = cashCount(minValueMethod(specifications, 'price'), true, 2)
                item.promotionMaxBalance = goodsData.promotionIntervalMax && cashCount(goodsData.promotionIntervalMax, true, 2)
                item.promotionMinBalance = goodsData.promotionIntervalMin && cashCount(goodsData.promotionIntervalMin, true, 2)
            } else {
                item.promotionPrice = specifications[0] && specifications[0].price && cashCount(specifications[0].price, true, 2)
                if (specifications.length) {
                    // item.promotionPrice = specifications[0] && specifications[0].price && cashCount(specifications[0].price, true, 2)
                    item.promotionBalance = specifications[0] && specifications[0].balanceAfterDiscount && cashCount(specifications[0].balanceAfterDiscount, true, 2)
                } else {
                    item.promotionBalance = goodsData.promotionIntervalMax && cashCount(goodsData.promotionIntervalMax, true, 2)
                }
            }

            item.promotionStartTime = timeutils.format(promotionData.startTime)
            item.promotionEndTime = timeutils.format(promotionData.endTime)
        })
        return data
    },
    // 商品状态查询
    goodsStates(val) {
        let states
        if (val.state === 'PUBLISHED' && val.putOnSaleTime > (new Date()).getTime()) {
            states = '待上架'
        } else {
            states = getGoodsState(val.state)
        }
        return states
    },
    goodsDetail(data, isEdit, isIntegral) {
        data.putOnSaleTime = data.goodsDTO && data.goodsDTO.putOnSaleTime && timeutils.format(data.goodsDTO.putOnSaleTime)
        let promotionData = (data.abstractPromotionEvent && data.abstractPromotionEvent.promotionData) || {}
        let abstractPromotionEvents = data.abstractPromotionEvents
        let taxProjectManageDTO = data.taxProjectManageDTO || {}
            // 积分商品-基因类型专用
        let mallGoods = data.mallGoods || {}
        let mallGoodsData = (mallGoods.goodsDTO && mallGoods.goodsDTO.goodsData) || {}
        mallGoods.final_price = mallGoodsData.finalPrice && cashCount(mallGoodsData.finalPrice, true)
            // 积分商品数量限制-start
        let pointsGoodsQuota = data.goodsDTO.pointsGoodsQuota
        data.goodsDTO.pointsGoodsQuota_show = (pointsGoodsQuota && pointsGoodsQuota.timeDimension) ?
            pointsGoodsQuota.number + '件/' + getEnumeration(pointsGoodsQuota.timeDimension, exchangeTimeDimensions) + '/用户' : '无数量限制'
            // 积分商品数量限制-end
        promotionData.promotionStatusColor = promotionColors[promotionData.promotionType]
        promotionData.promotion_type = promotionData.promotionType && getPromotionType(promotionData.promotionType)
        promotionData.start_time = promotionData.startTime && timeutils.format(promotionData.startTime)
        promotionData.end_time = promotionData.endTime && timeutils.format(promotionData.endTime)
        taxProjectManageDTO.rate = taxProjectManageDTO.sl && taxProjectManageDTO.sl + '%'
        if (data.goodsDTO && data.goodsDTO.goodsData) {
            let goodsData = data.goodsDTO.goodsData || {}
            let vendorInfo = goodsData.vendorInfo || {}
            let coupons = goodsData.coupons || []
            goodsData.pointsExchangeData = data.goodsDTO.pointsExchangeData
            goodsData.goodsCompanies = goodsData.goodsCompanies || []
                // goodsData.businessDepartmentId = data.goodsDTO.businessDepartmentId
            if (goodsData.goodsCompanyList && goodsData.goodsCompanyList.length) {
                goodsData.goodsCompanyList.forEach(item => {
                    goodsData.goodsCompanyName = goodsData.goodsCompanyName ? goodsData.goodsCompanyName + '/' + item.name : item.name
                })
            }

            if (goodsData.coupons) {
                goodsData.coupons = this.getCouponsList(goodsData.coupons)
            }
            goodsData.provide_invoice = (goodsData.provideInvoice || goodsData.provideInvoice === false) ? goodsData.provideInvoice.toString() : null
            vendorInfo.payment_account = vendorInfo.paymentAccount && getEnumeration(vendorInfo.paymentAccount, collectionsLabels)
            goodsData.final_price = goodsData.finalPrice && cashCount(goodsData.finalPrice, true)
            goodsData.goods_belong = goodsData.goodsBelong && getEnumeration(goodsData.goodsBelong, goodsBelongLabels)
            goodsData.shipping_mode = goodsData.shippingMode && getEnumeration(goodsData.shippingMode, shippingMode)
            goodsData.address = (goodsData.addresses && goodsData.addresses.join('/')) || ''
            let molecularCompanys = []
            goodsData.branches = goodsData.branches || []
            molecularCompanys = goodsData.branches.reduce((prev, cur) => {
                prev.push(cur.fullName)
                return prev
            }, [])
            goodsData.molecularCompany = (molecularCompanys && molecularCompanys.join('/')) || ''
            if (goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
                goodsData.final_detail_price = '¥' + cashCount(goodsData.priceIntervalMin, true) + '--¥' + cashCount(goodsData.priceIntervalMax, true)
            } else {
                goodsData.final_detail_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true)
            }
            goodsData.afterSalesPolicyId = isIntegral ? goodsData.afterSalesPolicyId : (goodsData.afterSalesPolicyId ? goodsData.afterSalesPolicyId : 'null')
            goodsData.goods_type = goodsData.type && getGoodsType(goodsData.type)
            goodsData.cycle_type = getCycleTypes(goodsData.cycleType)
            if (goodsData.genePackage) {
                goodsData.genePackage.forEach(item => {
                    item.cycle_type = item.cycleType && getCycleTypes(item.cycleType)
                    item.period = (item.cycle + item.cycle_type) || null
                    goodsData.genePackage_names = goodsData.genePackage_names ? (goodsData.genePackage_names + ' / ' + item.name) : item.name
                })
            }
            if (goodsData.paymentModes && goodsData.paymentModes.length) {
                goodsData.paymentModes.forEach(item => {
                    let name = getEnumeration(item, paymentModes)
                    goodsData.payment_modes = goodsData.payment_modes ? (goodsData.payment_modes + '/' + name) : name
                })
            }
            let specifications = data.specifications || []
            let goodsSpecifications = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items) || []
            specifications.forEach(etem => {
                    goodsSpecifications.forEach(atem => {
                        if (etem.itemId === atem.itemId) {
                            atem.promotionPrice = etem.price && cashCount(etem.price, true)
                            atem.salerRewardMoney = atem.salesReward && cashCount(atem.salesReward.money, true)
                            atem.inviterRewardMoney = atem.inviterReward && cashCount(atem.inviterReward.money, true)
                            atem.salerRewardMoney_show = atem.salesReward && cashCount(atem.salesReward.money, true, 2)
                            atem.justSalesman = atem.inviterReward && atem.inviterReward.justSalesman
                            atem.inviterRewardMoney_show = atem.inviterReward && cashCount(atem.inviterReward.money, true, 2)
                        }
                    })
                })
                // 如果是编辑页面，不需要对没有规格的商品做默认规格处理
            if (!isEdit) {
                if (abstractPromotionEvents && abstractPromotionEvents.length > 0) {
                    abstractPromotionEvents.forEach((item, index) => {
                        let promotionDatas = item.promotionData || {}
                        promotionDatas.promotion_type = promotionDatas.promotionType && getPromotionType(promotionDatas.promotionType)
                        promotionDatas.start_time = promotionDatas.startTime && timeutils.format(promotionDatas.startTime)
                        promotionDatas.end_time = promotionDatas.endTime && timeutils.format(promotionDatas.endTime)
                        promotionDatas.specifications = this.getSpecificationsPromotion(goodsData, item)
                            //   this.$set(promotionDatas, 'specifications', this.getSpecificationsPromotion(goodsData, item.detailData, promotionDatas))
                        promotionDatas.promotionStatusColor = promotionColors[promotionDatas.promotionType]
                    })
                }
                goodsData.specifications = this.getSpecificationsPromotion(goodsData)
            } else {
                let specificationsItems = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items) || []
                if (specificationsItems && specificationsItems.length > 0) {
                    specificationsItems.forEach((etem, index) => {
                        etem.show_price = (etem.price && cashCount(etem.price, true)) || ''
                        etem.deposit_show = (etem.deposit && cashCount(etem.deposit, true)) || null
                        etem.deposit_show_detail = (etem.deposit && cashCount(etem.deposit, true, 2)) || null
                        etem.balance_show = (etem.balance && cashCount(etem.balance, true, 2)) || null
                        etem.show_detail_price = (etem.price && cashCount(etem.price, true, 2)) || null
                    })
                } else {
                    goodsData.noSpecificationsDeposit_show = goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true)
                    goodsData.balance_show = goodsData.noSpecificationsBalance && cashCount(goodsData.noSpecificationsBalance, true, 2)
                }
            }
        }
        return data
    },
    // 规格和促销活动的处理
    getSpecificationsPromotion(goodsData, val) {
        goodsData = JSON.parse(JSON.stringify(goodsData))
        let promotionData = (val && val.promotionData) || {}
        let promotionDetailData = (val && val.detailData) || []
        let specificationsItems = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items) || []
        if (specificationsItems && specificationsItems.length > 0) {
            specificationsItems.forEach((etem, index) => {
                etem.balance_show = (etem.balance && cashCount(etem.balance, true, 2)) || null
                etem.show_price = (etem.price && cashCount(etem.price, true)) || ''
                etem.show_detail_price = (etem.price && cashCount(etem.price, true, 2)) || null
                etem.deposit_show = (etem.deposit && cashCount(etem.deposit, true)) || null
                etem.deposit_show_detail = (etem.deposit && cashCount(etem.deposit, true, 2)) || null
                    // 促销活动跟商品 规格关联
                if (promotionDetailData) {
                    promotionDetailData.forEach(item => {
                        if (item.goodsId === goodsData.goodsId) {
                            let discountGoodsData = item.discountGoodsData
                            discountGoodsData.forEach(atem => {
                                if (atem.specificationId === etem.itemId) {
                                    if (promotionData.promotionType === 'SNAP_UP') {
                                        etem.promotion_price = cashCount(atem.snapUpPrice, true, 2)
                                    } else if (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
                                        etem.promotion_price = cashCount(atem.discount, true, 2)
                                    }
                                }
                            })
                        }
                    })
                }
            })
        } else {
            goodsData.specifications = []
            if (goodsData.specifications.length === 0) {
                goodsData.specifications.push({
                    name: '',
                    items: []
                })
            }
            if (promotionDetailData && promotionDetailData.length > 0) {
                promotionDetailData.forEach(item => {
                    if (item.goodsId === goodsData.goodsId) {
                        let discountGoodsData = JSON.parse(JSON.stringify(item.discountGoodsData))
                        discountGoodsData.forEach(atem => {
                            if (!atem.specificationId) {
                                if (promotionData.promotionType === 'SNAP_UP') {
                                    item.promotion_price = cashCount(atem.snapUpPrice, true, 2)
                                } else if (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
                                    item.promotion_price = cashCount(atem.discount, true, 2)
                                }
                                goodsData.specifications[0].items.push({
                                    name: '默认规格',
                                    show_detail_price: goodsData.finalPrice && cashCount(goodsData.finalPrice, true, 2),
                                    promotion_price: item.promotion_price,
                                    deposit_show: (goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true)) || null,
                                    deposit_show_detail: (goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true, 2)) || null,
                                    balance_show: (goodsData.noSpecificationsBalance && cashCount(goodsData.noSpecificationsBalance, true, 2)) || null
                                })
                            }
                        })
                    }
                })
            } else {
                goodsData.specifications[0].items.push({
                    name: '默认规格',
                    show_detail_price: goodsData.finalPrice && cashCount(goodsData.finalPrice, true, 2),
                    deposit_show: (goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true)) || null,
                    deposit_show_detail: (goodsData.noSpecificationsDeposit && cashCount(goodsData.noSpecificationsDeposit, true, 2)) || null,
                    balance_show: (goodsData.noSpecificationsBalance && cashCount(goodsData.noSpecificationsBalance, true, 2)) || null
                })
            }
        }
        return JSON.parse(JSON.stringify(goodsData.specifications))
            // console.log('specifications', goodsData.specifications)
    },
    goodsGroupList(data) {
        data.forEach(item => {
            item.sorting_strategy = getCollationRules(item.sortingStrategy)
            item.isSsystem = item.system ? '是' : '否'
            item.isVisible = item.visible ? '是' : '否'
            item.created_date = timeutils.format(item.createdDate)
        })
        return data
    },
    getIntegralExchangeList(data) {
        data.forEach(item => {
            item.created_date = timeutils.format(item.createdDate)
            item.goods_number = item.placementDetails.goods && item.placementDetails.goods.number
            item.score = item.paymentSummary && item.paymentSummary.items[0] && item.paymentSummary.items[0].amount
            item.pay_real = item.paymentSummary && item.paymentSummary.total
            item.order_status = getIntegralOrderStatus(item.status)
            item.goodsBelong = getEnumeration(item.goods[0].goodsBelong, goodsBelongLabels)
        })
        return data
    },
    getIntegralExchangeByUserId(data) {
        data.forEach(item => {
            item.name = item.goods[0].name
            item.created_date = timeutils.format(item.createdDate)
            item.pay_real = item.paymentSummary && item.paymentSummary.total ? ('-' + item.paymentSummary.total) : ''
            item.order_status = getIntegralOrderStatus(item.status)
        })
        return data
    },
    getRefundPointsList(data) {
        data.forEach(item => {
            let apply = (item.refundmentDetails && item.refundmentDetails.apply) || {}
            let specificationItem = item.specificationItem || {}
            let placementDetails = item.placementDetails || {}
            let placementGoods = (item.placementDetails && item.placementDetails.goods) || {}
            let goodsItem = (item.goods && item.goods[0]) || {}
            item.created_date = timeutils.format(item.orderTime)
            item.totalAmount = item.paymentSummary && item.paymentSummary.total && '¥' + cashCount(item.paymentSummary.total, true, 2)
            item.order_status = placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE' && item.orderStatus === 'WAITING_FOR_PAYMENT' ? (item.isBalanceWaitingPayment ? '待支付尾款' : '待支付订金') : item.orderStatus && getOrderStatus(item.orderStatus)
            item.goods_name = item.goods && item.goods[0] && item.goods[0].name
            item.refund_amount = apply.amount && cashCount(apply.amount, true, 2)
            item.refund_points = apply.amount
            item.sales_price = (specificationItem.price && '¥' + cashCount(specificationItem.price, true, 2)) || (goodsItem.finalPrice && '¥' + cashCount(goodsItem.finalPrice, true, 2)) || ('¥' + '0.00')
                //   item.goods_type = goodsItem.type && getGoodsType(goodsItem.type)
            item.goods_number = placementGoods.number
            item.reality_price = (item.paymentTotal && '¥' + cashCount(item.paymentTotal, true, 2)) || '¥' + '0.00'
            item.refundmentType = apply.refundmentType && getRefundmentTypeIntegral(apply.refundmentType, true)
            item.orderRefundStatus = item.refundmentDetails && item.refundmentDetails.status && getOrderRefundIntegralStatus(item.refundmentDetails.status)
            item.applyTime = apply.applyTime && timeutils.format(apply.applyTime)
            item.goodsName = goodsItem.name
            item.orederType = (item.type && getEnumeration(item.type, userOrderTypes)) || null
        })
        return data
    },
    getIntegralDetail(data) {
        let apply = (data.refundmentDetails && data.refundmentDetails.apply) || {}
        let refundmentDetails = data.refundmentDetails || {}
        let refundStatusHistory = (data.refundmentDetails && data.refundmentDetails.refundStatusHistory) || null
        let vendorInfo = (data.goods && data.goods[0] && data.goods[0].vendorInfo) || {}
        let specificationItem = data.specificationItem || {}
        let expressDetails = data.expressDetails || {}
        let goods = (data.goods && data.goods[0]) || {}
        let placementDetails = data.placementDetails || {}
        let invoice = (placementDetails && placementDetails.invoice) || {}
        let patient = data.patient || {}
        let paymentModeSummary = data.paymentModeSummary || []
        let goodsData = (data && data.goods && data.goods[0]) || {}
        if (goodsData.goodsCompanyList && goodsData.goodsCompanyList.length) {
            goodsData.goodsCompanyList.forEach(item => {
                goodsData.goodsCompanyName = goodsData.goodsCompanyName ? goodsData.goodsCompanyName + '/' + item.name : item.name
            })
        }
        data.paymentMode = (placementDetails && placementDetails.paymentMode && getEnumeration(placementDetails.paymentMode, paymentModes)) || '全款'
        specificationItem.balance_show = specificationItem.balance && cashCount(specificationItem.balance, true, 2)
        specificationItem.deposit_show = specificationItem.deposit && cashCount(specificationItem.deposit, true, 2)
        data.refundProcessMode = refundmentDetails.refundProcessMode && getEnumeration(refundmentDetails.refundProcessMode, refundModes)
        invoice.invoice_type = invoice.invoiceType && getEnumeration(invoice.invoiceType, invoiceProvideTypesDo)
        invoice.title_type = invoice.titleType && getEnumeration(invoice.titleType, invoiceObject)
        patient.sex = patient.gender && genderFormat(patient.gender)
        patient.birth_day = patient.birthday && timeutils.format(patient.birthday, 'date')
        patient.idCardType = patient.identityCardType && getEnumeration(patient.identityCardType, identityCardTypes)
        data.orderRefundStatus = data.refundmentDetails && data.refundmentDetails.status && getOrderRefundIntegralStatus(data.refundmentDetails.status)
        patient.marry = patient.married ? '已婚' : '未婚'
        if (paymentModeSummary.length) {
            paymentModeSummary.forEach(item => {
                item.amount_show = item.amount && ('¥' + cashCount(item.amount, true, 2))
            })
        }
        // let shipping=
        let paymentDetails = data.paymentDetails || {}
        let balancePaymentDetails = data.balancePaymentDetails || {}
        data.goods_name = goods.name
            // 订单价格（及优惠）相关信息
        let summaryItems = (data.paymentSummary && data.paymentSummary.items) || []
        data.totalAmount = (data.paymentSummary && data.paymentSummary.total && cashCount(data.paymentSummary.total, true, 2)) || '--'
        summaryItems.forEach(item => {
            item.amount_show = '¥' + (item.amount && cashCount(item.amount, true, 2)) || 0
        })
        data.shipingTime = expressDetails.time && timeutils.format(expressDetails.time)
        data.shippingMode = goods.shippingMode && getEnumeration(goods.shippingMode, shippingMode)
            // data.samples=expressDetails.samples&&
        goods.afterSalesPolicy = data.afterSalesPolicy ? data.afterSalesPolicy : '--'
        goods.afterSalesPolicyName = data.afterSalesPolicyName ? data.afterSalesPolicyName : '--'
        data.paymentTime = paymentDetails.time && timeutils.format(paymentDetails.time)
        data.balancePaymentTime = balancePaymentDetails.time && timeutils.format(balancePaymentDetails.time)
        data.balance_show_amount = (balancePaymentDetails && cashCount(balancePaymentDetails.amount, true)) || 0
        data.balanceChannelName = balancePaymentDetails && balancePaymentDetails.channel && getChannelName(balancePaymentDetails.channel)
        if (expressDetails.samples && expressDetails.samples.length > 0) {
            expressDetails.samples.forEach(item => {
                item.sample_type = item.sampleType && getEnumeration(item.sampleType, sampleType)
            })
        }
        data.order_status = data.orderStatus && (placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE' &&
            data.orderStatus === 'WAITING_FOR_PAYMENT' ? (data.isBalanceWaitingPayment ? '待支付尾款' : '待支付订金') : getOrderStatus(data.orderStatus))
        data.payment_account = vendorInfo.paymentAccount && getEnumeration(vendorInfo.paymentAccount, collectionsLabels)
        data.goods_type = goods.type && getGoodsType(goods.type)
        data.show_amount = (paymentDetails && cashCount(paymentDetails.amount, true)) || 0
        data.payment_total = (data.paymentTotal && cashCount(data.paymentTotal, true, 2)) || 0
        data.created_date = data.createdDate && timeutils.format(data.createdDate)
        data.refundmentType = apply.refundmentType && getRefundmentTypeIntegral(apply.refundmentType, true)
        data.applyTime = apply.applyTime && timeutils.format(apply.applyTime)
        data.refund_amount = apply.amount && cashCount(apply.amount, true, 2)
        data.refund_points = apply.amount
        apply.show_amount = apply.amount && cashCount(apply.amount, true)
        data.refunded_amount = refundmentDetails.refundedAmount && cashCount(refundmentDetails.refundedAmount, true)
        data.channelName = paymentDetails && paymentDetails.channel && getChannelName(paymentDetails.channel)
        if (apply.refundmentType === 'MONEY') {
            data.refund_resean = (apply.reason && getOnlyRefundReason(apply.reason)) || apply.reason
        } else {
            data.refund_resean = (apply.reason && getRefundReturn(apply.reason)) || apply.reason
        }
        data.refund_sampleId = apply.sampleIds && apply.sampleIds.join('/')
        data.is_got = apply.isGot ? '已收到货' : '未收到货'
        let samples = (data.expressDetails && data.expressDetails.samples) || null
        if (samples) {
            samples.forEach(item => {
                data.sampleIds = data.sampleIds ? (data.sampleIds + '/' + item.sampleId) : item.sampleId
            })
        }
        if (refundStatusHistory) {
            refundStatusHistory.forEach(item => {
                data[item.refundStatus + '_time'] = timeutils.format(item.time)
            })
        }
        data.rejectTime = refundmentDetails.rejectTime && timeutils.format(refundmentDetails.rejectTime)
        return data
    },
    getDetectionPackageEntities(data) {
        data.forEach((item, index) => {
            item.isSelect = false
            item.index = index
            item.createdTime = timeutils.format(item.createdDate)
        })
        return data
    },

    getCouponsList(data) {
        data.forEach(item => {
            let couponData = item.couponData || {}
            item.startTime = timeutils.format(couponData.startTime)
            item.endTime = timeutils.format(couponData.endTime)
            item.startTime_day = timeutils.format(couponData.startTime, 'date')
            item.used_type = couponData.usedType && getEnumeration(couponData.usedType, usedTypes)
            item.endTime_day = timeutils.format(couponData.endTime, 'date')
            item.validity_date = timeutils.format(couponData.startTime, 'date') + '至' + timeutils.format(couponData.endTime, 'date')
            item.publishType = getPublishType(item.grantType)
            item.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
            item.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
            item.discountType = getDiscountType(couponData.discountType)
            item.getAmount = item.amount - item.surplusAmount
            if (item.status === 'ACTIVATED') {
                this.ACTIVATED_status(item, couponData)
                setInterval(_ => {
                    this.ACTIVATED_status(item, couponData)
                }, 5000)
            } else {
                item.coupon_status = getCouponStatus(item.status)
            }
        })
        return data
    },
    ACTIVATED_status(item, couponData) {
        if (new Date().getTime() < couponData.startTime) {
            item.coupon_status = '未开始'
        } else if (new Date().getTime() >= couponData.startTime && new Date().getTime() <= couponData.endTime) {
            item.coupon_status = '进行中'
        } else if (new Date().getTime() > couponData.endTime) {
            item.coupon_status = '已结束'
        }
    },
    couponDetail(data) {
        let couponData = data.couponData || {}
        let auditInfo = data.auditInfo || {}
        couponData.discount_show = couponData.discountType === 'FIXED_AMOUNT' ? cashCount(couponData.discount, true) : couponData.discount
        couponData.discount_show_shape = couponData.discountType === 'FIXED_AMOUNT' ? cashCount(couponData.discount, true) + '元' : cashCount(couponData.discount, true) + '折'
        data.coupon_status = getCouponStatus(data.status)
        data.used_type = couponData.usedType && getEnumeration(couponData.usedType, usedTypes)
        data.publishType = data.grantType === 'INVITE_NEW_USER_REWARD' ? (getPublishType(data.grantType) + '(每邀请一个新用户，邀请人获得一张)') : getPublishType(data.grantType)
        data.grantObj = getGrantObj(data.grantObject)
        couponData.thresholdOf_amount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
        data.validity_date = timeutils.format(couponData.startTime) + '至' + timeutils.format(couponData.endTime)
        data.audit_time = timeutils.format(auditInfo.auditTime)
        data.mallUserQueryText = data.mallUserCriteria && this.mallUserCriteriaData(data.mallUserCriteria)
        return data
    },
    mallUserCriteriaData(data) {
        let mallUserQueryText = null
        let whiteListData = null
        if (data.whiteList && data.whiteList.length) {
            data.whiteList.forEach(item => {
                if (item.forAllUser) {
                    mallUserQueryText = '全部用户'
                    whiteListData = 'forAllUser'
                } else if (item.gender) {
                    mallUserQueryText = mallUserQueryText || (item.gender === 'FEMALE' ? '全部女用户' : (item.gender === 'MALE' ? '全部男用户' : null))
                    whiteListData = item.gender
                } else if (item.role) {
                    mallUserQueryText = mallUserQueryText || item.role === 'DOCTOR_USER' ? '全部医护人员' : null
                } else {
                    mallUserQueryText = mallUserQueryText || (item.bindCps ? '全部CPS用户' : (item.bindCps === false ? '全部非CPS用户' : null))
                }
            })
        }
        if (data.blackList && data.blackList.length) {
            data.blackList.forEach(item => {
                if (item.enableSalesMan && whiteListData === 'forAllUser') {
                    mallUserQueryText = '全部非业务员'
                }
            })
        }
        return mallUserQueryText
    },
    getPromotionList(data) {
        data.forEach((item, index) => {
            item.index = index
            item.startTime = item.promotionData && item.promotionData.startTime && timeutils.format(item.promotionData.startTime)
            item.endTime = item.promotionData && item.promotionData.endTime && timeutils.format(item.promotionData.endTime)
            item.startTime_day = timeutils.format(item.promotionData.startTime, 'date')
            item.endTime_day = timeutils.format(item.promotionData.endTime, 'date')
            item.validity_date = item.startTime && item.endTime && (item.startTime + ' 至 ' + item.endTime)
            item.promotionType = item.promotionData && item.promotionData.promotionType && getPromotionType(item.promotionData.promotionType)
            item.promotionStatus = getEnumeration(item.status, promotionStatusArr)
        })
        return data
    },
    promotionDetail(data) {
        let auditInfo = data.auditInfo || {}
        data.promotionType = data.promotionData && data.promotionData.promotionType && getPromotionType(data.promotionData.promotionType)
        data.startTime = data.promotionData && data.promotionData.startTime && timeutils.format(data.promotionData.startTime)
        data.endTime = data.promotionData && data.promotionData.endTime && timeutils.format(data.promotionData.endTime)
        data.validity_date = data.startTime && data.endTime && (data.startTime + ' 至 ' + data.endTime)
        data.promotionStatus = getEnumeration(data.status, promotionStatusArr)
        let fullReductionDiscount = data.fullReductionDiscount || {}
        fullReductionDiscount.fullReductionType_show = getEnumeration(fullReductionDiscount.fullReductionType, fullReductionTypes)
        if (fullReductionDiscount.fullReductions && fullReductionDiscount.fullReductions.length) {
            fullReductionDiscount.fullReductions.forEach(item => {
                item.discount_show = cashCount(item.discount, true, 2)
                item.discountCondition_show = fullReductionDiscount.fullReductionType === 'MONEY' ? cashCount(item.discountCondition, true, 2) : item.discountCondition
            })
        }
        // (data.promotionData && data.promotionData.promotionType && data.promotionData.promotionType === 'CASH_BACK')
        //   ? getEnumeration(data.status, promotionStatusArr) : getCouponStatus(data.status)
        data.reword_money_show = data.rewardContent && data.rewardContent.money && cashCount(data.rewardContent.money, true)
        data.reword_money_show_detail = data.rewardContent && data.rewardContent.money && cashCount(data.rewardContent.money, true, 2)
        data.mallUserQueryText = data.mallUserCriteria && this.mallUserCriteriaData(data.mallUserCriteria)
        data.audit_time = auditInfo.auditTime && timeutils.format(auditInfo.auditTime)
        if (data.detailData && data.detailData.length) {
            data.detailData.forEach(item => {
                item.snapUp_price = (item.buyerCashBack && cashCount(item.snapUpPrice, true)) || null
                item.discount_show = (item.discount && cashCount(item.discount, true, 2)) || null
                item.promotional_price = (item.promotionalPrice && cashCount(item.promotionalPrice, true, 2)) || null
                item.buyer_cashBack = (item.buyerCashBack && cashCount(item.buyerCashBack, true, 2)) || null
                item.sharer_cashBack = (item.sharerCashBack && cashCount(item.sharerCashBack, true, 2)) || null
                if (item.goodsDTO && item.goodsDTO.goodsData) {
                    let goodsData = item.goodsDTO.goodsData
                    if (goodsData.specifications && goodsData.specifications.length > 0 && goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
                        item.final_price = '¥' + cashCount(goodsData.priceIntervalMin, true) + '-¥' + cashCount(goodsData.priceIntervalMax, true)
                    } else {
                        item.final_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true)
                    }
                }
                let discountGoodsData = item.discountGoodsData || {}
                discountGoodsData.forEach(etem => {
                    if (etem.buyerCouponsBack && etem.buyerCouponsBack.length) {
                        etem.buyerCouponsBack.forEach(atem => {
                            let couponData = atem.couponData || {}
                            atem.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
                            atem.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true, 2)
                        })
                    }
                    if (etem.sharerCouponsBack && etem.sharerCouponsBack.length) {
                        etem.sharerCouponsBack.forEach(atem => {
                            let couponData = atem.couponData || {}
                            atem.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
                            atem.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
                        })
                    }
                })
            })
        }
        if (data.couponsPackageData && data.couponsPackageData.length) {
            data.couponsPackageData.forEach(item => {
                let couponData = item.couponData
                item.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
                item.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
            })
        }
        return data
    },
    technologyCycle(data) {
        data.period = data.testCycle && (Number(data.testCycle.match(/P(\S*)D/)[1]) + getDayTypes(data.dayType))
        data.cycle = Number(data.testCycle.match(/P(\S*)D/)[1])
        return data
    },

    bannersPositions(data) {
        data.forEach((item, index) => {
            item.index = index + 1
            item.size = item.extensionInfo.width + 'px × ' + item.extensionInfo.height + 'px'
        })
        return data
    },
    // 第三方供应商列表数据处理
    getVendorsList(data) {
        data.forEach(item => {
            let base = item.base || {}
            item.vender_type = base.typeName
        })
        return data
    },
    // 老带新数据处理
    customerBringNew(data) {
        data.forEach(item => {
            item.oldCustomer = item.oldCustomer || {}
            item.newCustomer = item.newCustomer || {}
            item.achieve_date = timeutils.format(item.achieveDate, 'date')
            item.oldCustomer.customerRewardMoney = item.oldCustomerRewardMoney || null
            item.newCustomer.customerRewardMoney = item.newCustomerRewardMoney || null
            item.oldCustomer = this.rewardData(item.oldCustomer, 2, true)
            item.oldCustomer = datas.cpsContractData(item.oldCustomer)
            item.newCustomer = datas.cpsContractData(item.newCustomer)
            if (item.recordUserType === 'OLD') {
                // item.newCustomer = {}
            } else {
                item.newCustomer = this.rewardData(item.newCustomer, 2, true)
            }
            item.newCustomer.contractInformation = item.newCustomer.contractInformation || []
            item.oldCustomer.contractInformation = item.oldCustomer.contractInformation || []
            if (item.oldCustomer.contractInformation.length) {
                item.newCustomer.contractInformation.forEach(atem => {
                    if (atem.productInformation && atem.productInformation.length) {
                        atem.productInformation.forEach(etem => {
                            etem.motherName = atem.motherName
                            etem.contractCode = atem.contractCode
                            etem.cpsRegion = atem.cpsRegion
                        })
                    }
                })
                item.oldCustomer.contractInformation.forEach(atem => {
                    if (atem.productInformation && atem.productInformation.length) {
                        atem.productInformation.forEach(etem => {
                            etem.motherName = atem.motherName
                            etem.contractCode = atem.contractCode
                            etem.cpsRegion = atem.cpsRegion
                        })
                    }
                })
            }
        })

        return data
    },
    // 老带新用户数据分别处理
    // continue是否保留两位小数(价钱)
    rewardData(data, isNumber, isList) {
        data.reward_date = timeutils.format(data.rewardDate, 'date')
        data.reward_status = getEnumeration(data.rewardStatus, rewardStatus)
        let rewardMoney = data.rewardStatus === 'NO_REWARD' ? (data.customerRewardMoney) : (data.reward && data.reward.money)
        if (isList && isNumber) {
            data.moneyRewardAmount = (rewardMoney && cashCount(rewardMoney, true, 2)) || null
        } else if (data.rewardStatus === 'NO_REWARD') {
            data.moneyRewardAmount = (rewardMoney && cashCount(rewardMoney, true)) || null
        } else if (isNumber) {
            data.couponRewardAmount = (data.reward && data.reward.couponTotalAmount && cashCount(data.reward.couponTotalAmount, true, 2)) || 0
            data.moneyRewardAmount = (rewardMoney && cashCount(rewardMoney, true, 2)) || 0
            data.couponRewardAmount = (!data.couponRewardAmount && !data.moneyRewardAmount) ? null : data.couponRewardAmount
            data.moneyRewardAmount = (!data.couponRewardAmount && !data.moneyRewardAmount) ? null : data.moneyRewardAmount
        } else {
            data.couponRewardAmount = (data.reward && data.reward.couponTotalAmount && cashCount(data.reward.couponTotalAmount, true)) || '--'
            data.moneyRewardAmount = (rewardMoney && cashCount(rewardMoney, true)) || '--'
        }
        if (data.reward && data.reward.discountCoupons && data.reward.discountCoupons.length > 0) {
            data.reward.discountCoupons.forEach(item => {
                item.discountCoupon.discount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.discount && '¥' + cashCount(item.discountCoupon.couponData.discount, true, 2)
                item.discountCoupon.thresholdOfAmount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.thresholdOfAmount && cashCount(item.discountCoupon.couponData.thresholdOfAmount, true)
            })
        }
        data.CPSbindDate = timeutils.format(data.bindDate, 'date')
        data.CPSbindDate = timeutils.format(data.bindDate, 'date')
        return data
    },
    customerBringNewDetail(data) {
        data.achieve_date = timeutils.format(data.achieveDate, 'date')
        data.oldCustomer = data.oldCustomer || {}
        data.newCustomer = data.newCustomer || {}
        data.oldCustomer.customerRewardMoney = data.oldCustomerRewardMoney || null
        data.newCustomer.customerRewardMoney = data.newCustomerRewardMoney || null
        data.oldCustomer = this.rewardData(data.oldCustomer, true)
        data.newCustomer = this.rewardData(data.newCustomer, true)
        data.newCustomer = datas.cpsContractData(data.newCustomer)
        data.oldCustomer = datas.cpsContractData(data.oldCustomer)

        data.newCustomer.contractInformation = data.newCustomer.contractInformation || []
        data.oldCustomer.contractInformation = data.oldCustomer.contractInformation || []
        if (data.newCustomer.contractInformation.length) {
            data.newCustomer.contractInformation.forEach(item => {
                if (item.productInformation && item.productInformation.length) {
                    item.productInformation.forEach(etem => {
                        etem.motherName = item.motherName
                        etem.contractCode = item.contractCode
                        etem.cpsRegion = item.cpsRegion
                    })
                }
            })
        }
        if (data.oldCustomer.contractInformation.length) {
            data.oldCustomer.contractInformation.forEach(item => {
                if (item.productInformation && item.productInformation.length) {
                    item.productInformation.forEach(etem => {
                        etem.motherName = item.motherName
                        etem.contractCode = item.contractCode
                        etem.cpsRegion = item.cpsRegion
                    })
                }
            })
        }
        return data
    },
    getQrCodeList(data) {
        data.forEach(item => {
            item.created_date = item.createdDate && timeutils.format(item.createdDate)
        })
        return data
    },
    qrCodeDetailList(data) {
        data.forEach(item => {
            item.created_date = item.createdDate && timeutils.format(item.createdDate)
        })
        return data
    },
    importedCustomer(data) {
        data.forEach(item => {
            item.last_modified_date = item.lastModifiedDate && timeutils.format(item.lastModifiedDate)
            if (item.invalidReasons && item.invalidReasons.length) {
                item.invalidReasons.forEach(etem => {
                    item.invalid_reason = item.invalid_reason ? (item.invalid_reason + '/' + getEnumeration(etem, invalidReasonsArr)) : getEnumeration(etem, invalidReasonsArr)
                })
            }
        })
        return data
    }
}